
export default function ColorCurve(canvas, callback, points, otherCurvesPoints) {
	'use strict';

	this.points = points || [];
	this.currentPoint = -1;
	this.c = document.querySelector(`[data-id="${canvas}"]`);
	this.ctx = this.c.getContext('2d');
	this.height = this.c.height;
	this.width = this.c.width;
	this.redraw = 0;
	this.values = [];
	this.rgb = [];
	this.onChange = callback;
	this.blockPoint = false;
	this.colors = {
		line: {
			Y: '#494949',
			R: '#7f0000',
			G: '#007f00',
			B: '#000079'
		}
	}

	if (this.height != this.width) {
		return undefined;
	}

	if (this.points.length == 0) {
		this.points.push({ x: 0, y: 0 });
		this.points.push({ x: 1.0, y: 1.0 });
	}

	var me = this;

	this.c.addEventListener('mousedown', function (ev) {
		me.mouseDown(ev);
	}, false);

	this.c.addEventListener('mouseup', function (ev) {
		me.mouseUp(ev);
		me.draw();
	}, false);

	// this.c.addEventListener('mouseout', function (ev) {}, false);

	this.c.addEventListener('mousemove', function (ev) {
		me.mouseMove(ev);
		if (me.redraw == 1) {
			me.draw();
			me.redraw = 0;
		}
	}, false);

	this.draw();
	this.updateValues();
}

// Update the RGB array to fit the new curve values.
ColorCurve.prototype.updateValues = function () {
	'use strict';

	this.rgb.splice(0, this.rgb.length);
	for (var i = 0; i < 1024; i++) { // Use 1024 points for the curve. 256 is not enough as we interpolate too much.
		this.rgb.push(this.getY(i / 1023.0));
		// console.log(this.getY(i / 255.0));
	}

	if (typeof this.onChange !== "undefined") {
		this.onChange();
	}

}

// Compare 2 points
ColorCurve.prototype.isEqual = function (p1, p2) {
	'use strict';

	if (p1.x == p2.x && p1.y == p2.y) {
		return true;
	} else {
		return false;
	}

}

// Draw the curve
ColorCurve.prototype.draw = function (drawPoints = true) {
	var p1, p4;

	this.values.splice(0, this.values.length);
	this.ctx.clearRect(0, 0, this.width, this.height);
	// this.drawGrid();

	for (var i = 0; i < this.points.length - 1; i++) {
		if (i < 1) p1 = this.points[0];
		else p1 = this.points[i - 1];

		if (i + 2 > this.points.length - 1) p4 = this.points[i + 1];
		else p4 = this.points[i + 2];

		this.quadratic(p1, this.points[i], this.points[i + 1], p4);
	}

	// this.drawRGBCurves();
	if (drawPoints) this.drawPoints();
}

// ColorCurve.prototype.drawRGBCurves = function () {
// 	'use strict';

// 	if ($(this.ctx.canvas).attr('class').indexOf('curvesRGB') > -1) {
// 		let p1, p4;

// 		lutify.getActiveBlock().curves.forEach((curve, valuesIndex) => {
// 			if (valuesIndex == 0) return;
// 			if (valuesIndex == 1) this.ctx.strokeStyle = this.colors.line.R;
// 			if (valuesIndex == 2) this.ctx.strokeStyle = this.colors.line.G;
// 			if (valuesIndex == 3) this.ctx.strokeStyle = this.colors.line.B;

// 			for (var i = 0; i < lutify.getActiveBlock().values[valuesIndex].length - 1; i++) {
// 				if (i < 1) p1 = lutify.getActiveBlock().values[valuesIndex][0];
// 				else p1 = lutify.getActiveBlock().values[valuesIndex][i - 1];

// 				if (i + 2 > lutify.getActiveBlock().values[valuesIndex].length - 1) p4 = lutify.getActiveBlock().values[valuesIndex][i + 1];
// 				else p4 = lutify.getActiveBlock().values[valuesIndex][i + 2];

// 				this.quadratic(p1, lutify.getActiveBlock().values[valuesIndex][i], lutify.getActiveBlock().values[valuesIndex][i + 1], p4, true);
// 			}
// 		})
// 	}
// }

// The background grid
// ColorCurve.prototype.drawGrid = function () {
// 	'use strict';

// 	var space = this.width / 4.0;

// 	this.ctx.beginPath();
// 	this.ctx.lineWidth = 1;
// 	this.ctx.strokeStyle = '#282828';

// 	for (var i = 0; i < this.height - space; i += space) {
// 		this.ctx.moveTo(0, i + space); this.ctx.lineTo(this.height, i + space);
// 	}
// 	for (var i = 0; i < this.height - space; i += space) {
// 		this.ctx.moveTo(i + space, 0); this.ctx.lineTo(i + space, this.height);
// 	}
// 	this.ctx.stroke();
// }

// Main function. Calculate curve coeficients and draw the curve
ColorCurve.prototype.quadratic = function (p1, p2, p3, p4, strokeColor = false) {
	// 'use strict';

	var x0, x1, x2, x3, y0, y1, y2, y3, dx, dy;

	if ( ! strokeColor) {
		if ($(this.ctx.canvas).attr('class').indexOf('curvesRGB') > -1) {
			this.ctx.strokeStyle = this.colors.line.Y;
		}
		else if ($(this.ctx.canvas).attr('class').indexOf('curvesR') > -1) {
			this.ctx.strokeStyle = this.colors.line.R;
		}
		else if ($(this.ctx.canvas).attr('class').indexOf('curvesG') > -1) {
			this.ctx.strokeStyle = this.colors.line.G;
		}
		else if ($(this.ctx.canvas).attr('class').indexOf('curvesB') > -1) {
			this.ctx.strokeStyle = this.colors.line.B;
		}
		else {
			this.ctx.strokeStyle = this.colors.line.Y;
		}
	}

	this.ctx.lineWidth = 1;
	var slope = 0;

	x0 = p2.x;
	x3 = p3.x;

	y0 = p2.y;
	y3 = p3.y;

	dx = x3 - x0;
	dy = y3 - y0;

	x1 = ((2.0 * x0) / 3.0) + (x3 / 3.0)
	x2 = (x0 / 3.0) + ((2.0 * x3) / 3.0);


	if (this.isEqual(p1, p2) && this.isEqual(p3, p4)) {
		y1 = y0 + (dy / 3.0);
		y2 = y0 + ((dy * 2.0) / 3.0);
	}
	if (this.isEqual(p1, p2) && !this.isEqual(p3, p4)) {

		slope = ((p4.y) - y0) / (p4.x - x0);
		y2 = y3 - ((slope * dx) / 3.0);
		y1 = y0 + ((y2 - y0) / 2.0);

	}
	if (!this.isEqual(p1, p2) && this.isEqual(p3, p4)) {
		slope = (y3 - (p1.y)) / (x3 - p1.x);

		y1 = y0 + ((slope * dx) / 3.0);
		y2 = y3 + ((y1 - y3) / 2.0);
	}

	if (!this.isEqual(p1, p2) && !this.isEqual(p3, p4)) {
		slope = (y3 - (p1.y)) / (x3 - p1.x);
		y1 = y0 + ((slope * dx) / 3.0);
		slope = ((p4.y) - y0) / (p4.x - x0);
		y2 = y3 - ((slope * dx) / 3.0);
	}

	this.ctx.beginPath();
	this.ctx.moveTo(x0 * this.width, this.height - (y0 * this.height));

	var step = (x3 - x0) / 20.0;
	var tx = x0;

	for (var i = 0.0; i <= 1.05; i += 0.05) {

		var ty = (y0 * Math.pow((1 - i), 3)) +
			(3 * y1 * Math.pow((1 - i), 2) * i) +
			(3 * y2 * (1 - i) * i * i) +
			(y3 * i * i * i);

		this.ctx.lineTo(tx * this.width, this.height - (ty * this.height));
		this.values.push({ x: tx, y: ty });
		tx = tx + step;

	}

	let n = this.points.length - 1;

	this.ctx.moveTo(0, this.height - (this.points[0].y * this.height));
	this.ctx.lineTo(this.points[0].x * this.width, this.height - (this.points[0].y * this.height));

	this.ctx.moveTo(this.points[n].x * this.width, this.height - (this.points[n].y * this.height));
	this.ctx.lineTo(this.width, this.height - (this.points[n].y * this.height));

	this.ctx.stroke();


	// Uncomment this for view the control points
	/*
	this.ctx.fillStyle = '#00ff00';
	this.ctx.beginPath();

	this.ctx.moveTo(x1,y1);
	this.ctx.arc(x1,y1, 3, 0 , 2 * Math.PI, false);
	this.ctx.moveTo(x2,y2);
	this.ctx.arc(x2,y2, 3, 0 , 2 * Math.PI, false);

	this.ctx.fill();
	*/
	return true;

}

// Draw the control points
ColorCurve.prototype.drawPoints = function () {
	'use strict';

	if ($(this.ctx.canvas).hasClass('curvesRGB')) this.ctx.fillStyle = '#D1CACA';
	else if ($(this.ctx.canvas).hasClass('curvesR')) this.ctx.fillStyle = '#FB0005';
	else if ($(this.ctx.canvas).hasClass('curvesG')) this.ctx.fillStyle = '#1ABE05';
	else if ($(this.ctx.canvas).hasClass('curvesB')) this.ctx.fillStyle = '#001AFE';

	this.ctx.beginPath();

	for (var i = 0; i < this.points.length; i++) {
		this.ctx.moveTo(this.points[i].x * this.width, this.height - (this.points[i].y * this.height));
		this.ctx.arc(this.points[i].x * this.width, this.height - (this.points[i].y * this.height), 5, 0, 2 * Math.PI, false);

	}
	this.ctx.fill();

}




ColorCurve.prototype.mouseDown = function (event) {
	'use strict';

	this.currentPoint = -1;
	var canObj = $(this)[0];
	var elem = canObj.ctx.canvas;

	$('.selected_block').removeClass('selected_block');
	$(elem).closest('.smart-curve-block').addClass('selected_block');

	if (!event) event = window.event;

	var el = $(this)[0].c;
	var id = $(el).attr('data-id');

	var x = (event.pageX - $(`[data-id="${id}"]`).offset().left) / this.width,
		y = (event.pageY - $(`[data-id="${id}"]`).offset().top) / this.height;

	var dis = 10000;
	var punto = -1;
	var pointsNum = this.points.length;

	for (var i = 0; i < pointsNum; i++) {
		var x1 = x - this.points[i].x;
		var y1 = y - (1.0 - this.points[i].y);

		var tdis = x1 * x1 + y1 * y1;
		tdis = Math.sqrt(tdis);

		if (tdis < dis) {
			dis = tdis;
			punto = i;
		}
	}

	if (event.buttons == 1) {
		if (dis < 0.1) {
			this.currentPoint = (dis < 8.0) ? punto : this.currentPoint;
		} else {
			this.addNewPoint(x, y);
		}
	}

	else if (event.buttons == 2) {
		if (dis < 0.1) {
			var activePoint = (dis < 8.0) ? punto : this.currentPoint;
			if (activePoint !== 0 && activePoint !== (pointsNum - 1)) {
				this.deletePoint(activePoint);
			}
		}
	}
}



ColorCurve.prototype.addNewPoint = function (currentX, currentY) {

	var dis = 10000;
	var punto = -1;

	for (let i = 0; i < this.values.length; i++) {
		var valX1 = currentX - this.values[i].x;
		var valY1 = currentY - (1.0 - this.values[i].y);

		var tdis = valX1 * valX1 + valY1 * valY1;
		tdis = Math.sqrt(tdis);

		if (tdis < dis) {
			dis = tdis;
			punto = i;
		}
	}

	if (dis <= 0.1) {

		for (let i = 0; i < this.points.length; i++) {
			var px = this.points[i].x;
			var py = (this.points[i].y);

			if ((currentX + (1.0 - currentY)) < (px + py)) {
				var beforePoint = i;
				var newPoint = {
					x: currentX,
					y: 1.0 - currentY
				};
				this.points.splice(beforePoint, 0, newPoint);
				this.currentPoint = beforePoint;
				break;
			}
		}
	}

	this.updateValues();
	this.draw();

}


ColorCurve.prototype.deletePoint = function (currentPoint) {

	this.points.splice(currentPoint, 1);
	this.currentPoint = 0;
	this.updateValues();
	this.draw();
}


ColorCurve.prototype.mouseUp = function (event) {
	'use strict';

	if (this.currentPoint != -1) this.updateValues();
	this.blockPoint = false;
	this.currentPoint = -1;
}


ColorCurve.prototype.mouseMove = function (event) {
	'use strict';

	if (event.buttons == 1) {
		var prevx, nextx;

		if (this.currentPoint == -1) return;
		if (this.currentPoint > 0) prevx = this.points[this.currentPoint - 1].x; else prevx = 0;
		if (this.currentPoint == this.points.length - 1) nextx = 1.0; else nextx = this.points[this.currentPoint + 1].x;

		var el = $(this)[0].c;
		var id = $(el).attr('data-id');

		var x = (event.pageX - $(`[data-id="${id}"]`).offset().left) / $(`[data-id="${id}"]`).width();
		var y = 1.0 - ((event.pageY - $(`[data-id="${id}"]`).offset().top) / $(`[data-id="${id}"]`).height());

		if (x > prevx && x < nextx) {
			this.points[this.currentPoint].x = x;
			this.points[this.currentPoint].y = y;
			this.redraw = 1;
			this.blockPoint = false;
		} else {
			this.blockPoint = true;
		}

		this.updateValues();
	}

}

// Return the normalized Y value for the specified X value. X should be passed normnalized too
ColorCurve.prototype.getY = function (xpos) {
	'use strict';

	if (xpos < this.values[0].x) xpos = this.values[0].x;
	if (xpos > this.values[this.values.length - 1].x) xpos = this.values[this.values.length - 1].x;

	for (var i = 0; i < this.values.length - 2; i++) {
		if (xpos >= this.values[i].x && xpos < this.values[i + 1].x) break;
	}
	var valuea = (xpos - this.values[i].x) / (this.values[i + 1].x - this.values[i].x);
	var valueb = valuea * (this.values[i + 1].y - this.values[i].y);

	var ret = this.values[i].y + valueb;

	if (ret < 0.0) return 0.0;
	if (ret > 1.0) return 1.0;

	return ret;
}
